import { createContext } from "react";

import type { DeliverySchedulingContextType } from "./DeliverySchedulingContext.types";

export const DeliverySchedulingContext = createContext<DeliverySchedulingContextType | undefined>(undefined);
